const getters = {
  getColorTheme: (state) => state.colorTheme,
  getLogo: (state) => state.logo,
  getSidebarMenuDefault: (state) => state.sidebarMenuDefault,
  getSidebarMenu: (state) => state.sidebarMenu,
  getHeaderPolicies: (state) => state.headerPolicies,
  getHeaderClaims: (state) => state.headerClaims,
  getPreviousAccount: (state) => state.previousAccount,
  getLocale: (state) => state.locale,
  getHeaderTableColumn: (state) => state.headerTableColumn,
  getPlatformConfigFilter: (state) => state.platformConfigFilter,
  getInternalToolsFilter: (state) => state.internalToolsFilter,
};

export default getters;
